// import React, { useEffect, useState } from "react";
// // import "./PresaleCard.css";

// const PresaleCard = ({
//   stage = 28,
//   price = 0.112,
//   raised = 10607504,
//   target = 11975000,
// }) => {
//   const [progressValue, setProgressValue] = useState(0);

//   useEffect(() => {
//     const increment = Math.ceil(target / 100);
//     const interval = setInterval(() => {
//       setProgressValue((prev) => {
//         if (prev >= raised) {
//           clearInterval(interval);
//           return raised;
//         }
//         return Math.min(prev + increment, raised);
//       });
//     }, 10);

//     return () => clearInterval(interval);
//   }, [raised, target]);

//   return (
//     <div
//       className="app-container"
//       style={{
//         padding: "60px 20px",
//         backgroundColor: "#f9f9ff",
//       }}
//     >
//       <div
//         style={{
//           maxWidth: "1200px",
//           margin: "0 auto",
//         }}
//       >
//         {/* ✅ Top Title */}
//         <h2
//           style={{
//             textAlign: "center",
//             marginBottom: "50px",
//             fontSize: "2rem",
//             fontWeight: "700",
//           }}
//         >
//           Buy OWNX – Join the Presale
//         </h2>

//         {/* ✅ Layout: Text Left, Card Right */}
//         <div
//           style={{
//             display: "flex",
//             flexWrap: "wrap",
//             justifyContent: "space-between",
//             gap: "40px",
//             alignItems: "flex-start",
//           }}
//         >
//           {/* Left Side Text */}
//           <div
//             style={{
//               flex: "1 1 45%",
//               fontSize: "18px",
//               lineHeight: "1.7",
//               color: "#222",
//             }}
//           >
//             <p style={{ marginBottom: "20px" }}>
//               <strong>Your early entry into the OwnXChain movement starts here.</strong>
//             </p>
//             <p>
//               OWNX isn’t just another token. It’s the heartbeat of OwnXChain, powering everything from gas fees and staking to governance and real-world tokenization.
//             </p>
//           </div>

//           {/* Right Side Card */}
//           <div className="content" style={{ flex: "1 1 45%" }}>
//             <div className="blob-wrapper">
//               <div className="blob"></div>
//             </div>

//             <div className="presale-card">
//               <div className="header">
//                 <span>Stage {stage}</span>
//                 <span>1 NEX = ${price.toFixed(3)}</span>
//               </div>

//               <progress
//                 className="progress-element"
//                 value={progressValue}
//                 max={target}
//               ></progress>

//               <div className="raised-text">
//                 <span>USDT RAISED:</span>
//                 <strong>
//                   ${progressValue.toLocaleString()} / ${target.toLocaleString()}
//                 </strong>
//               </div>

//               <div className="buttons">
//                 <a href="#" className="btn primary">
//                   Join Presale ↗
//                 </a>
//                 <a href="#" className="btn secondary">
//                   Whitepaper ↗
//                 </a>
//               </div>

//               <div className="audit-footer">
//                 <div className="audit-item">
//                   <img
//                     src="assets/icon-1/solid proof logo.svg"
//                     alt="Certik"
//                   />

//                   <span>
//                     SOLID PROOF
//                     <br />
//                     Smart Contract Audit
//                   </span>
//                 </div>
//                 <div className="audit-item">
//                   <img
//                     src="assets/icon-1/solid proof logo.svg"
//                     alt="Certik"
//                   />
//                   <span>
//                     CERTIK
//                     <br />
//                     Smart Contract Audit
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PresaleCard;





// import React, { useEffect, useState } from "react";


// const PresaleCard = ({
//   stage = 28,
//   price = 0.112,
//   raised = 10607504,
//   target = 11975000,
//   phase1User = 100,
//   phase1Target = 100000,
// }) => {
//   const [progressValue, setProgressValue] = useState(0);

//   useEffect(() => {
//     const increment = Math.ceil(target / 100);
//     const interval = setInterval(() => {
//       setProgressValue((prev) => {
//         if (prev >= raised) {
//           clearInterval(interval);
//           return raised;
//         }
//         return Math.min(prev + increment, raised);
//       });
//     }, 10);

//     return () => clearInterval(interval);
//   }, [raised, target]);

//   return (
//     <section className="presale-card-section">
//       <div className="presale-card-container">
//         <div className="presale-card-left">
//           <h2>Join <span className="highlight">OWNX</span> Today</h2>
//           <p className="subtitle">
//             Your early entry into the OwnXChain movement starts here.
//           </p>
//           <p>
//             OWNX isn’t just another token. It’s the heartbeat of OwnXChain,
//             powering everything from gas fees and staking to governance and real-world tokenization.
//           </p>
//           <div className="button-group">
//             <a href="#" className="btn primary">Join Now ↗</a>
//             <a href="#" className="btn secondary">Whitepaper ↗</a>
//           </div>
//         </div>

//         <div className="presale-card-right">
//           <div className="card">
//             <div className="card-header">
//               <span>Phase 1</span>
//               <span>1 OWNX = ${price}</span>
//             </div>

//             <div className="progress-wrapper">
//               <label>USDT Raised</label>
//               <div className="progress-bar">
//                 <div
//                   className="progress-fill"
//                   style={{ width: `${(progressValue / target) * 100}%` }}
//                 ></div>
//               </div>
//               <p className="progress-text">
//                 ${progressValue.toLocaleString()} / ${target.toLocaleString()}
//               </p>
//             </div>

//             <div className="progress-wrapper">
//               <label>Users Joined</label>
//               <div className="progress-bar">
//                 <div
//                   className="progress-fill secondary"
//                   style={{ width: `${(phase1User / phase1Target) * 100}%` }}
//                 ></div>
//               </div>
//               <p className="progress-text">
//                 {phase1User} / {phase1Target.toLocaleString()}
//               </p>
//             </div>

//             <div className="audit-footer">
//               <div className="audit-item">
//                 <img src="assets/icon-1/solid proof logo.svg" alt="Solid Proof" />
//                 <span>
//                   Solid Proof<br />
//                   Smart Contract Audit
//                 </span>
//               </div>
//               <div className="audit-item">
//                 <img src="assets/icon-1/solid proof logo.svg" alt="Certik" />
//                 <span>
//                   Certik<br />
//                   Smart Contract Audit
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default PresaleCard;

import React, { useEffect, useState } from "react";
// import "./PresaleCard.css";

const PresaleCard = ({
  stage = 28,
  price = '--',
  raised = 10607504,
  target = 11975000,
  phase1User = 100,
  phase1Target = 100000,
}) => {
  const [progressValue, setProgressValue] = useState(0);

  useEffect(() => {
    const increment = Math.ceil(target / 100);
    const interval = setInterval(() => {
      setProgressValue((prev) => {
        if (prev >= raised) {
          clearInterval(interval);
          return raised;
        }
        return Math.min(prev + increment, raised);
      });
    }, 10);

    return () => clearInterval(interval);
  }, [raised, target]);

  return (
    <section className="presale-card-section bg ">
      <h2 className="main-heading">
        Join <span className="highlight">Zenochain </span> Today
      </h2>

      <div className="presale-card-container">
        <div className="presale-card-left">
          <p className="subtitle">
            Your early entry into the Zenochain  movement starts here.
          </p>
          <p>
            Zenochain  isn’t just another token. It’s the heartbeat of Zenochain
            ,
            powering everything from gas fees and staking to governance and
            real-world tokenization.
          </p>
        </div>

        <div className="presale-card-right">
          {/* <div className="blob-wrapper">
            <div className="blob"></div>
          </div> */}

          <div className="card">
            <div className="card-header">
              <span>Phase 1</span>
              <span>1 Zeno  = {price}</span>
            </div>

            <div className="progress-wrapper">
              <label>USDT Raised</label>
              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{ width: `${(progressValue / target) * 100}%` }}
                ></div>
              </div>
              <p className="progress-text">
                ${progressValue.toLocaleString()} / ${target.toLocaleString()}
              </p>
            </div>
            <div className="progress-wrapper">
              <label>Users Joined</label>
              <div className="progress-bar">
                <div
                  className="progress-fill secondary"
                  style={{ width: `${(phase1User / phase1Target) * 100}%` }}
                ></div>
              </div>
              <p className="progress-text">
                {phase1User} / {phase1Target.toLocaleString()}
              </p>
            </div>

            {/* Buttons inside card */}
            {/* <div className="button-group card-buttons">
             
               <a href="#" className="btn" style={{backgroundColor:'#a8721e',color:"white"}}>
                Join Now ↗
              </a>
              <a href="#" className="btn" style={{backgroundColor:'#a8721e',color:"white"}}>
                Whitepaper ↗
              </a>
            </div> */}
            <ul className="list list-lg-row gap-4 gap-lg-6 ">

              <li className="menu-list mx-4 mx-lg-0">
                <a
                  href="/"
                  className="gradient-btn-1 position-relative z-1 link d-inline-flex justify-content-center px-4 py-2 rounded fw-bold text-center"
                >
                  {" "}
                  Join Now ↗{" "}
                </a>
              </li>
              <li className="menu-list mx-4 mx-lg-0">
                <a
                  href="/"
                  className="gradient-btn-1 position-relative z-1 link d-inline-flex justify-content-center px-4 py-2 rounded fw-bold text-center"
                >
                  {" "}
                  Whitepaper ↗{" "}
                </a>
              </li>
            </ul>

            <div className="audit-footer">
              <div className="audit-item">
                <img src="assets/icon-1/solid proof logo.svg" alt="Solid Proof" />
                <span>
                  Solid Proof
                  <br />
                  Smart Contract Audit
                </span>
              </div>
              <div className="audit-item">
                <img src="assets/icon-1/solid proof logo.svg" alt="Certik" />
                <span>
                  Certik
                  <br />
                  Smart Contract Audit
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default PresaleCard;
